import { PageController } from '@client/components/_core/layout/PageController';
import { ProductEdit } from '@client/components/products-v2/ProductEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/products-v2/edit/$productId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit product',
        },
    },
    params: {
        parse({ productId }) {
            return {
                productId: BigInt(productId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ProductEdit action={['edit', Route.useParams().productId]} />
        </PageController>
    );
}
